import { ChangeDetectionStrategy, Component, Inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';

export interface ConfirmDialogData {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  hideCancelButton?: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent {
  private readonly defaults = {
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel'
  } as const;

  readonly message = signal(this.data.message);
  readonly title = signal(this.data.title ?? null);
  readonly confirmLabel = computed(() => this.data.confirmLabel ?? this.defaults.confirmLabel);
  readonly cancelLabel = computed(() => this.data.cancelLabel ?? this.defaults.cancelLabel);
  readonly danger = signal(this.data.danger ?? false);
  readonly hideCancelButton = signal(this.data.hideCancelButton ?? false);

  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) private readonly data: ConfirmDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
